import { documentationActions, schedulingTask, screeningAction } from 'src/redux/actions/constant';

const {
  DELETE_TASK_NOTE_SCHEDULING_REQUEST,
  DELETE_TASK_NOTE_SCHEDULING_SUCCESS,
  DELETE_TASK_NOTE_SCHEDULING_FAILURE,
  DELETE_TASK_NOTE_SCHEDULING_LOADING,
  DELETE_TASK_NOTE_SCHEDULING_RESET,
} = schedulingTask;

const initialState: object = {
  isDeletedTaskNote: false,
  response: null,
  loader: false,
};

export const deleteTherapistTaskNoteReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case DELETE_TASK_NOTE_SCHEDULING_SUCCESS: {
      return {
        ...state,
        isDeletedTaskNote: true,
        response: action.payload,
        loader: false,
      };
    }

    case DELETE_TASK_NOTE_SCHEDULING_FAILURE:
      return {
        ...state,
        isDeletedTaskNote: false,
        response: action.payload,
        loader: false,
      };

    case DELETE_TASK_NOTE_SCHEDULING_LOADING:
      return {
        ...state,
        loader: true,
      };

    case DELETE_TASK_NOTE_SCHEDULING_RESET:
      return initialState;

    default:
      return state;
  }
};
